import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format a translated text from Kentico to replace <<text>> with a value
 *
 * Usage:
 *   value | placeholder
 * Example:
 *   {{ These are my <<number>> cats |  placeholder('3')}}
 *   formats to: These are my 3 cats
 */

@Pipe({
    name: 'placeholder2',
    standalone: true
})
export class Placeholder2Pipe implements PipeTransform {
	transform(value: any, replacementValue: any): string {
		if (value && replacementValue) {
			// this value gets inserted from another pipe transform, address-or-name.
			// if we end up not needing to apply this placeholder replacement
			if (value.indexOf('**REMOVE PLACEHOLDER2**') !== -1) {
				value = value.replace(value.slice(value.indexOf('[['), value.indexOf(']]') + 2), '');
				value = value.replace('**REMOVE PLACEHOLDER2**', '');
				// there can be a space at the end for english
				value = value.replace(' ?', '?');
				return value;
			} else {
				return value.replace(value.slice(value.indexOf('[['), value.indexOf(']]') + 2), replacementValue);
			}
		}
		return value;
	}
}
